
<template>
  <el-dialog
    :title="$parent.dialogName"
    :visible.sync="dialogVisible"
    width="70%"
    @close="close"
  >
    <div>车辆信息</div>
    <el-form ref="lease" :model="lease" :rules="rules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="车架号">
            <span class="value">{{ form.frame_num }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="车辆型号" prop="type">
            <el-select
              v-model="form.type_code"
              placeholder="请选择"
              disabled="disabled"
              style="width: 100%"
            >
              <el-option
                v-for="item in options.type_code"
                :key="item.id"
                :label="item.type"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="Tbox编号">
            <span class="value">{{ form.tbox_num }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="车辆品牌" prop="brand">
            <el-select
              v-model="form.brand_code"
              placeholder="请选择"
              style="width: 100%"
              disabled="disabled"
            >
              <el-option
                v-for="item in options.brand_code"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="底盘型号">
            <span class="value">{{ form.chassis }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="车牌号">
            <span class="value">{{ form.license_num }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div>租赁信息</div>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="身份证" prop="card">
            <el-input v-model="lease.card" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="驾照类型" prop="driver">
            <el-select
              v-model="lease.driver"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in options.driver"
                :key="item.id"
                :label="item.name"
                :value="item.id + ''"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="名称" prop="name">
            <el-input v-model="lease.name" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="驾照号码" prop="driver_num">
            <el-input
              v-model="lease.driver_num"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="联系电话" prop="iphone">
            <el-input v-model="lease.iphone" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="当前里程数" prop="current_mile">
            <el-input v-model="lease.current_mile" placeholder="请输入">
              <template slot="append">km</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="租赁日期" prop="start_time">
            <el-date-picker
              v-model="lease.start_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="计划归还日期" prop="specified_time">
            <el-date-picker
              v-model="lease.specified_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="$parent.dialogName == '回收'">
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="结束日期" prop="end_time">
              <el-date-picker
                v-model="lease.end_time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="结束里程数" prop="over_mile">
              <el-input v-model="lease.over_mile" placeholder="请输入"
                ><template slot="append">km</template></el-input
              >
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-button type="primary" @click="submitForm('lease')">确认</el-button>
      <el-button @click="close">取消</el-button>
    </el-form>
  </el-dialog>
</template>
<script>
import { GetCarDetailes, getCarLeaseByCarNum, UpdateCarLease, queryCarMileage } from '@/api/car'
import { GetDataSelectXing, GetdataSelectType, GetdataSelectCar } from '@/api/system'
export default {
  data () {
    return {
      dialogVisible: true,
      form: {
        name: '',
        id: '',
      },
      lease: {
        card: ''
      },
      options: {
        type_code: [],
        brand_code: [],
        model: [],
        driver: [
          { id: "A1", name: "A1" },
          { id: "A2", name: "A2" },
          { id: "A3", name: "A3" }
        ]
      },
      rules: {
        iphone: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        driver_num: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        current_mile: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        start_time: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        driver: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        card: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        end_time: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        over_mile: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        specified_time: [
          { required: true, message: '必填', trigger: 'blur' }
        ]
      },
    }
  },
  mounted () {
    this.form.id = this.$parent.childform.id
    this.form.car_status = this.$parent.childform.type
    this.form.frame_num = this.$parent.childform.frame_num
    this.GetCarDetailese(this.form.id, this.form.car_status)
    this.getCarLeases(this.form.id, this.form.car_status, this.form.frame_num)
    this.GetSelect()
    this.getCarMileage()
  },
  methods: {
    GetSelect () {
      GetDataSelectXing().then(res => {
        this.options.brand_code = res.data.content
      })
      GetdataSelectType().then(res => {
        this.options.type_code = res.data.content
      })
      GetdataSelectCar().then(res => {
        this.options.model = res.data.content
      })
    },
    GetCarDetailese (id, car_status) {
      GetCarDetailes({ id, car_status }).then(res => {
        this.form = res.data.content[0]

      })
    },
    getCarLeases (id, car_status, frame_num) {
      getCarLeaseByCarNum({ id, car_status, frame_num }).then(res => {
        this.lease = res.data.content[0]
      })
    },
    getCarMileage () {
      if (this.$parent.childform.tbox_num != null) {
        var snt = [this.$parent.childform.tbox_num]
        let sn = JSON.stringify(snt)
        queryCarMileage({ "sn": sn }).then(res => {
          if (res.code != 1) {
            this.lease.over_mile = res.data[0].totalMileage
          }
        })
      }
    },
    close () {
      this.$parent.dialogVisible = false
    },
    submitForm (formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$parent.dialogName === '租赁') {
            var start_time = new Date(this.lease.start_time).getTime()
            var specified_time = new Date(this.lease.specified_time).getTime()
            if (start_time > specified_time) {
              this.$message.error('计划回收时间不能小于租赁时间')
              return
            }
          }
          if (this.$parent.dialogName === '回收') {
            var start_time = new Date(this.lease.start_time).getTime()
            var end_time = new Date(this.lease.end_time).getTime()
            if (start_time > end_time) {
              this.$message.error('回收时间不能小于租赁时间')
              return
            }
          }
          this.onSubmit()
        } else {
          return false
        }
      })
    },
    onSubmit () {
      this.lease.user_id = this.form.belong_userid
      this.lease.id = this.form.id
      this.lease.car_status = this.form.car_status
      this.lease.frame_num = this.form.frame_num
      UpdateCarLease(this.lease).then(res => {
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('保存成功!')
        this.close()
        this.$parent.search()
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.el-form {
  padding-right: 20px;
}
.container {
  .bnt-bottom {
    /deep/ .el-form-item__content {
      width: 100%;
      text-align: center;
      margin-top: 10px;
      margin-left: 0 !important;
    }
  }
}
.el-input.is-disabled .el-input__inner {
  background-color: "";
  border-color: "";
  color: "";
  cursor: "";
}
</style>